import React, { useContext } from 'react';
import { IFrame as Iframe, TmoCard } from '@tmobile/tmo-bps-syncup-web-component-lib';

import config from '../../../configs/config';
import SyncUpProductContext from '../../../context/SyncUpProductContext';

const {
  iframePetsURL,
  iframeTrackerURL,
  iframeWatchURL,
  iframeDriveURL,
  iframeFamilyURL
} = config.powerBiSettings;

function PowerBi() {
  const syncUpProductContext = useContext(SyncUpProductContext);
  const iframe = () => {
    switch (syncUpProductContext.syncUpAppName) {
      case 'TRACKER':
        return iframeTrackerURL;
      case 'KIDSWATCH':
        return iframeWatchURL;
      case 'DRIVE':
        return iframeDriveURL;
      case 'FAMILYLOCATION':
        return iframeFamilyURL;
      default:
        return iframePetsURL;
    }
  };

  return (
    <TmoCard>
      <Iframe src={iframe()} width="100%" height="836px" />
    </TmoCard>
  );
}

export default PowerBi;
